<ng-container *transloco="let t">
  <div
    id="announcement-bar"
    class="w-full border rounded-full px-6 py-3 font-dm bg-ld-warning-50 border-ld-warning flex items-center gap-3"
    role="alert"
  >
    <mat-icon id="announcement-bar-icon" class="w-5! h-5! text-[20px]! shrink-0 text-ld-warning" aria-hidden="true">
      warning
    </mat-icon>
    <p id="announcement-content" class="text-sm text-ld-neutral leading-5 m-0">
      <span class="font-bold">{{ t('commonHereToHelp') }}</span>
      <span class="font-bold">–</span>
      <span>{{ t('announcementBarDisasterRelief') }}</span>
    </p>
  </div>
</ng-container>
